<template>
  <div></div>
</template>
<script>
export default {
  name: 'AnswerRow'
}
</script>
